/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

export const adjustAcceptedRedirect = (locale: string, acceptedRedirect?: string): string => {
	if (!acceptedRedirect) return "";

	if (locale && !acceptedRedirect.includes("?")) {
		const underscoreLocale = locale.replace("-", "_");
		return `${acceptedRedirect}?language=${underscoreLocale}`;
	}

	return acceptedRedirect;
};
